import axios from 'axios'
import JwtService from '@/services/jwt'

export const API_BASE_URL = 'https://komirchi.expe.uz/'

class CoreAxios extends JwtService {
  constructor({ headers = {}, baseURL = null, endpoint = '' }) {
    super({
      jwtOverrideConfig: {},
      axiosIns: axios.create({
        headers,
        baseURL: baseURL ? baseURL + endpoint : API_BASE_URL,
      }),
    })
  }

  get(url, config) {
    return this.axiosInstance.get(url, config).catch(error => Promise.reject(error))
  }

  post(url, body = {}, config = {}) {
    return this.axiosInstance
      .post(url, body, {
        ...config,
      })
      .catch(error => Promise.reject(error))
  }

  patch(url, body = {}, config = {}) {
    return this.axiosInstance
      .patch(url, body, {
        ...config,
      })
      .catch(error => Promise.reject(error))
  }

  put(url, body = {}) {
    return this.axiosInstance.put(url, body).catch(error => Promise.reject(error))
  }

  delete(url) {
    return this.axiosInstance.delete(url).catch(error => Promise.reject(error))
  }

  findAll({ params = {} }) {
    return this.post('/findAll', params)
  }

  findOne({ params = {} }) {
    return this.post('/findOne', params)
  }

  create({ params = {} }) {
    return this.post('', params)
  }

  update({ params = {} }) {
    return this.post('/update', params)
  }

  remove({ params = {} }) {
    return this.post('/remove', params)
  }
}

export default CoreAxios
